import type React from 'react';
import { Page as Component } from '~/components/specifics/vendors/settings/accounts/Page';

export const Page: React.FC = () => <Component />;
